/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrSddcProviderEnum } from './irrSddcProviderEnum';
import { ResourceTypeEnum } from './resourceTypeEnum';
import { IrrSddcAuth } from './irrSddcAuth';
import { IrrSddcMode } from './irrSddcMode';


export interface IrrSddcConfig { 
    /**
     * SDDC Config Enabled
     */
    enabled?: boolean;
    name?: string;
    id?: string;
    sddcProvider?: IrrSddcProviderEnum;
    sddcType?: ResourceTypeEnum;
    allowedModes?: IrrSddcMode;
    auth?: IrrSddcAuth;
}
export namespace IrrSddcConfig {
}


